import axios from "axios";

const actions = {
  cadastrarFacial: async (
    context,
    { id, base64_image, livesCheck = false }
  ) => {
    const tokenFacial = context.rootState.autenticacao.tokenFacial;

    //Gera o token do facial
    let data2 = JSON.stringify({
      doLivenessCheck: livesCheck,
      Images: [
        {
          imageType: "frontal",
          imageData: `${base64_image}`,
        },
      ],
    });

    let config2 = {
      method: "post",
      maxBodyLength: Infinity,
      url: `https://api.techtrue.com.br/api/v1/services/face/enroll/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenFacial}`,
      },
      data: data2,
    };

    const response = await axios(config2).then((response) => {
      if (response.data.result.code != 1000) {
        throw "err";
      } else {
        return response.data;
      }
    });

    return response;
  },
  cadastrarFacialLote: async (
    context,
    { id, imagesArray, livesCheck = false }
  ) => {
    const tokenFacial = context.rootState.autenticacao.tokenFacial;

    //Gera o token do facial
    let data2 = JSON.stringify({
      doLivenessCheck: livesCheck,
      Images: imagesArray,
    });

    let config2 = {
      method: "post",
      maxBodyLength: Infinity,
      url: `https://api.techtrue.com.br/api/v1/services/face/enroll/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenFacial}`,
      },
      data: data2,
    };

    const response = await axios(config2).then((response) => {
      if (response.data.result.code != 1000) {
        throw "err";
      } else {
        return response.data;
      }
    });

    return response;
  },

  getUsers: async (context, { search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`auth/users`, {
      params: {
        search,
      },
    });

    return response;
  },

  getFacesList: async (context) => {
    const api = context.rootState.autenticacao.apiFacial;
    const response = await api.get(`services/face/list`);

    return response;
  },

  excluirFace: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiFacial;
    const response = await api.delete(`services/face/${id}`);

    return response;
  },

  verificarFacial: async (
    context,
    { id, base64_image, livesCheck = false }
  ) => {
    const tokenFacial = context.rootState.autenticacao.tokenFacial;

    //Gera o token do facial
    let data2 = JSON.stringify({
      doLivenessCheck: livesCheck,
      Images: [
        {
          imageType: "frontal",
          imageData: `${base64_image}`,
        },
      ],
    });

    let config2 = {
      method: "post",
      maxBodyLength: Infinity,
      url: `https://api.techtrue.com.br/api/v1/services/face/${id}/verify`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenFacial}`,
      },
      data: data2,
    };

    const response = await axios(config2).then((response) => {
      if (response.data.result.code != 1002) {
        throw "err";
      } else {
        return response.data;
      }
    });

    return response;
  },

  identificarFacial: async (context, { base64_image, livesCheck = false }) => {
    const tokenFacial = context.rootState.autenticacao.tokenFacial;

    //Gera o token do facial
    let data2 = JSON.stringify({
      doLivenessCheck: livesCheck,
      Images: [
        {
          imageType: "frontal",
          imageData: `${base64_image}`,
        },
      ],
    });

    let config2 = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.techtrue.com.br/api/v1/services/face/identify",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenFacial}`,
      },
      data: data2,
    };

    const response = await axios(config2).then((response) => {
      if (response.data.result.code != 1008) {
        throw "err";
      } else {
        return response.data;
      }
    });

    return response;
  },

  templatesFacial: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiFacial;
    const response = await api.get(`services/face/templates/${id}`);

    return response;
  },
};

export const facialStore = {
  namespaced: true,
  actions,
};
